module.exports = __webpack_public_path__ + "static/media/noLeaseGraph.2b7b7692.png";